import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import { TransitionProps } from '@material-ui/core/transitions';
import * as React from 'react';
import i18n from '../resources/i18n';

const Transition = React.forwardRef(
	(
		props: TransitionProps & { children?: React.ReactElement<any, any> },
		ref: React.Ref<unknown>
	) => {
		return <Slide direction="up" ref={ref} {...props} />;
	}
);

interface IQuestionError {
	questionId: string;
	errorMessageList: string[];
}

/**
 * メッセージダイアログ
 */
export default class QuickModeMessageDialog extends React.Component<IMyProps> {
	public render() {
		const {
			open,
			onClickOk,
			onClose,
			title = 'エラーメッセージ',
			errorList,
			messageNs = 'message',
			questionErrorList,
			style,
			className,
		} = this.props;
		const messages: string[] = errorList.map(
			(item: string): string => {
				const message = i18n.t(item, { ns: messageNs });
				return message;
			}
		);
		const questionMessages: string[] = [];
		questionErrorList.forEach((item: IQuestionError) => {
			const questionName = '問題番号' + item.questionId + ':';
			questionMessages.push(questionName);
			item.errorMessageList.forEach((messageId: string) => {
				const message = i18n.t(messageId, { ns: messageNs });
				questionMessages.push(message);
			});
		});

		const dialogContent: React.CSSProperties = {
			maxHeight: '310px',
		};

		return (
			<Dialog
				className={className}
				open={open}
				TransitionComponent={Transition}
				keepMounted={true}
				onClose={onClose}
				aria-labelledby="alert-dialog-slide-title"
				aria-describedby="alert-dialog-slide-description"
				style={{ ...style, zIndex: 3000 }}
			>
				<DialogTitle id="alert-dialog-slide-title">
					{i18n.t(title, { ns: messageNs })}
				</DialogTitle>
				<DialogContent style={dialogContent}>
					<DialogContentText
						id="alert-dialog-slide-description"
						dangerouslySetInnerHTML={{
							__html: messages.join('<br/>'),
						}}
					/>
					<DialogContentText
						id="alert-dialog-slide-description"
						dangerouslySetInnerHTML={{
							__html: questionMessages.join('<br/>'),
						}}
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={onClickOk} color="primary">
						OK
					</Button>
				</DialogActions>
			</Dialog>
		);
	}
}

interface IMyProps {
	open: boolean;
	onClickOk: () => void;
	onClickCancel?: () => void;
	onClose: () => void;
	title?: string;
	errorList: string[];
	questionErrorList: IQuestionError[];
	messageNs?: string;
	style?: React.CSSProperties;
	className?: string;
}



// WEBPACK FOOTER //
// ./src/components/QuickModeMessageDialog.tsx